/** Normalize role string for comparisons (built-in and custom). */
export function normalizeRoleKey(role: string): string {
  return role.trim().toLowerCase().replace(/\s+/g, '-').replace(/_/g, '-');
}

export function isSuperAdminRole(role: string | undefined | null): boolean {
  if (!role) return false;
  return normalizeRoleKey(role) === 'super-admin';
}

/** Super-admin and admin may use the app during site maintenance mode. */
export function isAdminOrSuperAdminRole(role: string | undefined | null): boolean {
  if (!role) return false;
  const key = normalizeRoleKey(role);
  return key === 'super-admin' || key === 'admin';
}

/** Compare permission key lists (order-independent). */
export function permissionKeysEqual(a: string[], b: string[]): boolean {
  const sa = [...a].sort();
  const sb = [...b].sort();
  return sa.length === sb.length && sa.every((key, i) => key === sb[i]);
}
